import React, { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import prepareFilterParams from 'utils/prepareFilterParams'
import List from './components/List'
import styles from 'modules/Finance/PaymentProfiles/Invoices/payment-profiles-invoices.module.scss'
import FilterPanel from 'components/Filters/FilterPanel'
import useFiltersManager from 'utils/hooks/useFiltersManager'
import config from 'modules/Finance/PaymentProfiles/Invoices/filters'

const Invoices = () => {
  const { profileId } = useParams()
  const dispatch = useDispatch()
  const [page, setPage] = useState(1)

  const { data, loading, pagination, i18n } = useSelector((state) => ({
    data: state['finance/payment-profiles-invoices'].data,
    loading: state['finance/payment-profiles-invoices'].loading,
    pagination: state['finance/payment-profiles-invoices'].pagination,
    i18n: state['app'].i18n,
  }))

  const filterManager = useFiltersManager({
    filters: useSelector(
      (state) => state['finance/payment-profiles-invoices'].filters,
    ),
    config: config(),
    setAction: 'USER/PAYMENT_PROFILE_PAYMENTS_SET_FILTER',
    localStorageKey: 'payment-profiles/invoices',
  })

  useEffect(() => {
    dispatch({
      type: 'USER/DROP_USER_PAYMENT_PROFILE_PAYMENTS',
    })
    setPage(1)
  }, [filterManager.filters, profileId])

  useEffect(() => {
    dispatch({
      type: 'USER/GET_USER_PAYMENT_PROFILE_PAYMENTS',
      payload: {
        id: profileId,
        params: {
          ...prepareFilterParams(filterManager.filters),
          offset: (page - 1) * pagination.limit,
          limit: pagination.limit,
        },
      },
    })
  }, [filterManager.filters, page, profileId])

  const setNextPage = useCallback(() => setPage(page + 1), [page])

  return (
    <div className={styles['container']}>
      <FilterPanel
        filterManager={filterManager}
        className={styles['filter-panel']}
      />
      <List
        i18n={i18n}
        data={data}
        loading={loading}
        pagination={pagination}
        onNextPage={setNextPage}
        profileId={profileId}
        page={page}
      />
    </div>
  )
}

export default Invoices
